import { TFunction } from 'i18next';
import React from 'react';

import { SCHEDULED_STAFF_COLOR, REQUIRED_STAFF_COLOR } from '../../config';

interface ChartLegendProps {
  t: TFunction;
}

export const items = [
  {
    color: REQUIRED_STAFF_COLOR,
    text: 'form.required',
  },
  {
    color: SCHEDULED_STAFF_COLOR,
    text: 'schedule.staffed',
  },
];

type ChartLegendItemProps = {
  color: string;
} & React.PropsWithChildren;

const ChartLegendItem: React.FC<ChartLegendItemProps> = ({ color, children }) => (
  <div className="scheduling-chart__legend__item">
    <span className="scheduling-chart__legend__item-square">
      <span style={{ backgroundColor: color }} />
    </span>
    {children}
  </div>
);

export const ChartLegend: React.FC<ChartLegendProps> = ({ t }) => (
  <div className="scheduling-chart__legend">
    {items.map(({ color, text }) => (
      <ChartLegendItem key={text} color={color}>
        {t(text)}
      </ChartLegendItem>
    ))}
  </div>
);
